export const SIDE_BAR_MINI_WIDTH = 89;
export const SIDE_BAR_SHOW_TIT_MINI_WIDTH = 80;

export enum ContentEnum {
  // auto width
  FULL = 'full',
  // fixed width
  FIXED = 'fixed',
}

// menu theme enum
export enum ThemeEnum {
  DARK = 'dark',
  LIGHT = 'light',
}

export enum SettingButtonPositionEnum {
  AUTO = 'auto',
  HEADER = 'header',
  FIXED = 'fixed',
}

export enum SessionTimeoutProcessingEnum {
  ROUTE_JUMP,
  PAGE_COVERAGE,
}

/**
 * 权限模式
 */
export enum PermissionModeEnum {
  // role
  ROLE = 'ROLE',
  // black
  BACK = 'BACK',
  // route mapping
  ROUTE_MAPPING = 'ROUTE_MAPPING',
}

//  Route switching animation
export enum RouterTransitionEnum {
  ZOOM_FADE = 'zoom-fade',
  ZOOM_OUT = 'zoom-out',
  FADE_SIDE = 'fade-slide',
  FADE = 'fade',
  FADE_BOTTOM = 'fade-bottom',
  FADE_SCALE = 'fade-scale',
}

export enum LangEnum {
  EN_US = 'en-US',
  ZH_CN = 'zh-CN',
  KO_KR = 'ko-KR',
  AR_AE = 'ar-AE',
}
export enum LangPrefixEnum {
  en = LangEnum.EN_US,
  zh = LangEnum.ZH_CN,
  ko = LangEnum.KO_KR,
  ar = LangEnum.AR_AE,
}

export enum PollingTime {
  lang = 30 * 1000,
  middle = 15 * 1000,
  short = 5 * 1000,
  huge = 100 * 1000,
}
